import { I18nProvider } from 'react-admin';
import { IntlProvider } from '../utils/intl';

const i18nProvider = new IntlProvider() as I18nProvider;

export default i18nProvider;
